import { ROUTES } from '../../constants';
import * as types from '../types';

const moduleReducers = {
  quizSession: setQuizSession,
  quizSessionRedirect: setQuizzSessionRedirect,
};

function setQuizSession(state = {}, action) {
  switch (action.type) {
    case types.SET_QUIZ_SESSION:
      return action.payload;
    default:
      return state;
  }
}

function setQuizzSessionRedirect(state=ROUTES.EDITOR.MY_QUIZZES, action ){  
  switch (action.type) {
    case types.SET_QUIZ_SESSION_REDIRECT:
      return action.payload;
    default:
      return state;
  }
}


export default moduleReducers;
